import React from 'react'
import { Updater, async, fromJSX, Widget } from 'widgets-for-react'
import { emptyImage } from '../../../../../utils/image'
import { SpecialistPage } from '../../../cmsPageState'
import { SpecialistsBlock } from '../../blocksState'
import { SpecialistsBlockLayout } from './specialistsBlockLayout'
import { SpecialistsBlockState } from './specialistsBlockState'

export const specialistsBlockWidget = (
  block: SpecialistsBlock,
  department?: string
): Widget<Updater<SpecialistsBlockState>> =>
  async<SpecialistPage[]>(block.specialistsBlockState, pages =>
    fromJSX(() => (
      <SpecialistsBlockLayout
        index={block.index}
        inview={block.inview}
        department={department}
        title={block.title}
        intro={block.intro}
        specialists={pages.map((page: SpecialistPage) => ({
          title: page.specialist?.title,
          role: page.specialist?.role,
          image: page.image || emptyImage,
          url: page.url,
        }))}
        imageOptions={block.imageOptions}
      />
    ))
  )
